import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const LoginPage = lazy(() => import('./auth/LoginPage'));
const RegisterPage = lazy(() => import('./auth/RegisterPage'));
const ChangePasswordPage = lazy(() => import('./auth/ChangePasswordPage'));
const InviteAcceptPage = lazy(() => import('./auth/InviteAcceptPage'));
const ForgotPasswordPage = lazy(() => import('./auth/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('./auth/ResetPasswordPage'));
const FormList = lazy(() => import('./builder/FormList'));
const FormEditor = lazy(() => import('./builder/FormEditor'));
const ResponsesPage = lazy(() => import('./builder/ResponsesPage'));
const AdminUsersPage = lazy(() => import('./builder/AdminUsersPage'));
const FormPlayer = lazy(() => import('./runtime/FormPlayer'));

import RequireAuth from './auth/RequireAuth';

export default function App() {
  return (
    <Suspense fallback={<div className="p-6 text-sm opacity-60">Loading…</div>}>
      <Routes>
        <Route path="/" element={<Navigate to="/app" replace />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        {/* Public invite-accept landing; reached from the email. */}
        <Route path="/invites/:id" element={<InviteAcceptPage />} />
        {/* Public password-reset flow. */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:id" element={<ResetPasswordPage />} />

        <Route
          path="/app"
          element={
            <RequireAuth>
              <FormList />
            </RequireAuth>
          }
        />
        <Route
          path="/app/forms/:id"
          element={
            <RequireAuth>
              <FormEditor />
            </RequireAuth>
          }
        />
        <Route
          path="/app/forms/:id/responses"
          element={
            <RequireAuth>
              <ResponsesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/app/forms/:id/preview"
          element={
            <RequireAuth>
              <FormPlayer previewMode />
            </RequireAuth>
          }
        />
        <Route
          path="/app/admin/users"
          element={
            <RequireAuth>
              <AdminUsersPage />
            </RequireAuth>
          }
        />
        <Route
          path="/app/change-password"
          element={
            <RequireAuth>
              <ChangePasswordPage />
            </RequireAuth>
          }
        />

        <Route path="/f/:slug" element={<FormPlayer />} />

        <Route path="*" element={<div className="p-6">Not found.</div>} />
      </Routes>
    </Suspense>
  );
}
